import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import PageWidgetsRenderer from "../components/PageWidgetsRenderer";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// layout_mode=embedded pages render here, inside the existing admin
// Dashboard shell (sidebar/top banner) -- reachable via a nav_modules row
// pointing sip_target_path at /dashboard/pages/<slug>, same as any other
// custom nav entry (AI Architect, AI Usage). Standalone/branded/public
// pages use PortalView.js instead.
const PageView = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [bootstrap, setBootstrap] = useState(null);
  const [error, setError] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    let cancelled = false;
    setBootstrap(null);
    setError("");
    axios
      .get(`${API_BASE}/pages/${slug}/bootstrap`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .then((res) => {
        if (!cancelled) setBootstrap(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.response?.data?.detail || "Failed to load page.");
      });
    return () => {
      cancelled = true;
    };
  }, [slug, token]);

  // auto_redirect applies regardless of layout_mode -- a "thank you" page
  // should bounce back to wherever it points whether it's embedded in the
  // admin shell or a standalone portal. PortalView.js has the same effect.
  useEffect(() => {
    if (!bootstrap?.page?.auto_redirect_target_slug) return undefined;
    const seconds = bootstrap.page.auto_redirect_after_seconds || 5;
    const timer = setTimeout(() => {
      navigate(`/dashboard/pages/${bootstrap.page.auto_redirect_target_slug}`);
    }, seconds * 1000);
    return () => clearTimeout(timer);
  }, [bootstrap, navigate]);

  if (error) return <div className="text-red-600">{error}</div>;
  if (!bootstrap) return <div className="text-gray-400">Loading…</div>;

  return (
    <div>
      <h1 className="text-xl font-bold mb-4" style={{ color: "#e5e7eb" }}>
        {bootstrap.page.name}
      </h1>
      {/* Widgets (Tremor Card/Metric/etc.) are styled for a light
          background -- the Dashboard shell around this route is dark, so
          give them their own light surface rather than theming Tremor for
          dark mode (not configured anywhere in this app). PortalView.js
          doesn't need this -- it already renders on a light bg-gray-50. */}
      <div className="bg-gray-50 rounded-xl p-5">
        <PageWidgetsRenderer
          widgets={bootstrap.widgets}
          slug={slug}
          basePath="/dashboard/pages"
          apiBaseUrl={API_BASE}
          token={token}
        />
      </div>
    </div>
  );
};

export default PageView;
